
export const data = [
  {
    title: 'Prepare your responses',
    desc: `Understand the key requirements for the position and think of examples where you have demonstrated those skills. At Kraftshala, we want to understand not only why you are suitable for the role, your career progression and your achievements, but also what value you can bring to the overall business..`,
    img: "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46sfv9n.webp",
    imgMob: "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46qufbo.svg"
  },
  {
    title: 'Understand our proposition',
    desc: `Research Kraftshala, what we do as a business, who our competitors and customers are, our products, and our future opportunities and challenges in the Ed-tech space. `,
    img:"https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46sh2fk.webp",
    imgMob: "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46qvpev.svg"
  },
  {
    title: 'Be yourself',
    desc: `At Kraftshala, you can truly bring your authentic self to work. We continuously strive to develop a diverse and inclusive culture and look to hire candidates from a variety of backgrounds. Share what you are passionate about, your future aspirations and what motivates you.`,
    img:"https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46silp4.webp",
    imgMob: "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46qwv9t.svg"
  },
  {
    title: 'Get to know us',
    desc: `Interviews are a two-way conversation, so take the opportunity to ask the Hiring team any questions you have regarding the role, our culture, and values. This would help you decide whether we fit in your roadmap just yet, as much as it would help us decide whether or not we can bring you on board.`,
    img:"https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46sjymu.webp",
    imgMob: "https://d36rc1r950nl44.cloudfront.net/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46qzos0.svg"
  },
  
  
];